import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import AdminLogin from "./admin_login";
import AdminLayout from "./admin_layout";
import AdminDashboard from "./admin_dashboard";
import AdminStats from "./admin_stats";
import { AdminUsersList, AdminUserDetail } from "./admin_users";
import { AdminMatchesList, AdminMatchDetail } from "./admin_matches";
import { AdminServicesList, AdminServiceDetail } from "./admin_services";
import {
  AdminCommunitiesList,
  AdminCommunityDetail,
} from "./admin_communities";
import AdminReports from "./admin_reports";
import AdminBlocks from "./admin_blocks";
import AdminPoints from "./admin_points";
import AdminNotices from "./admin_notices";
import AdminRatings from "./admin_ratings";
import AdminSettings from "./admin_settings";
import { SESSION_KEY } from "./admin_ui";

export default function AdminScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(() => {
    try {
      return !!sessionStorage.getItem(SESSION_KEY);
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const onStorage = () => {
      try {
        setAuthed(!!sessionStorage.getItem(SESSION_KEY));
      } catch {}
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  if (!authed) {
    return (
      <AdminLogin
        onSuccess={() => {
          setAuthed(true);
          // 로그인 직후 admin 루트로 정규화 (sub-path 직접 진입한 경우)
          if (
            location.pathname !== "/miadmin" &&
            location.pathname.startsWith("/miadmin")
          ) {
            navigate(location.pathname + location.search, { replace: true });
          }
        }}
      />
    );
  }

  const handleLogout = () => {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch {}
    setAuthed(false);
    navigate("/miadmin", { replace: true });
  };

  return (
    <Routes>
      <Route element={<AdminLayout onLogout={handleLogout} />}>
        <Route index element={<AdminDashboard />} />
        <Route path="stats" element={<AdminStats />} />
        <Route path="users" element={<AdminUsersList />} />
        <Route path="users/:docId" element={<AdminUserDetail />} />
        <Route path="matches" element={<AdminMatchesList />} />
        <Route path="matches/:docId" element={<AdminMatchDetail />} />
        <Route path="services" element={<AdminServicesList />} />
        <Route path="services/:docId" element={<AdminServiceDetail />} />
        <Route path="communities" element={<AdminCommunitiesList />} />
        <Route path="communities/:docId" element={<AdminCommunityDetail />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="blocks" element={<AdminBlocks />} />
        <Route path="points" element={<AdminPoints />} />
        <Route path="notices" element={<AdminNotices />} />
        <Route path="ratings" element={<AdminRatings />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="*" element={<Navigate to="/miadmin" replace />} />
      </Route>
    </Routes>
  );
}
